import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=33bdeed7&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"
import style0 from "./SideNav.vue?vue&type=style&index=0&id=33bdeed7&prod&lang=scss"
import style1 from "./SideNav.vue?vue&type=style&index=1&id=33bdeed7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bdeed7",
  null
  
)

export default component.exports